// @ts-nocheck
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { objectToFormData } from "utils/ObjectUtils";
import { RtkqTagEnum } from "./Constants";
import {
  FineractHttp,
  FineractEDRHttp,
  SequestHttp,
  PublicHttp,
  FineractExternalHttp,
  HookHttp,
  NeduWrapperHttp,
  nipSupportHttp,
  ImpairmentHttp,
  paySyncHttp,
  outwardTransactionHttp,
} from "./Http";
import { logoutAction } from "./StoreActions";
import { downloadFile } from "./Utils";
import * as BusinessBankingTags from "constants/tags";
import { EnvKeys } from "constants/EnvKeys";

export const creditDirectApi = createApi({
  reducerPath: "creditDirect",
  baseQuery: fetchBaseQuery({
    baseUrl: `${EnvKeys.REACT_APP_LOANS_BETA_API}/api/v1`,
  }),
  endpoints: (builder) => ({
    resolveBVNDetails: builder.query({
      query: (bvn) => ({ url: `/Validation/SendOtpForBvn/${bvn}/private` }),
    }),
    getValidateOtherBank: builder.query({
      query: ({ path }) => ({
        url: `/validation/validateaccountnumberv2/${path.AccountNumber}/${path.BankCode}`,
      }),
    }),
  }),
});

export const cldAuthenticationApi = createApi({
  reducerPath: "cldAuthenticationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CDL_AUTHENTICATION_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set(
        "Authorization",
        `Bearer ${process.env.REACT_APP_CDL_AUTHENTICATION_API_KEY}`
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getChannels: builder.query({
      query: ({ ...params }) => ({
        url: "/v1/channel/findAll",
        params,
      }),
      providesTags: (data) => providesTags(RtkqTagEnum.CHANNELS),
    }),
    clickToDial: builder.mutation({
      query: ({ ...body }) => ({
        url: "/v1/x-cally/clickToDial",
        body: body,
        method: "post",
      }),
    }),
    createInteraction: builder.mutation({
      query: ({ ...body }) => ({
        url: "/v1/x-cally/createInteraction",
        body: body,
        method: "post",
      }),
      invalidatesTags: () => [RtkqTagEnum.ICALLY_INTERACTION],
    }),
    getEDRReconciliation: builder.query({
      query: (params) => ({
        url: "edr/paypoint/view",
        method: "GET",
        params,
      }),
      providesTags: (id) => [{ type: RtkqTagEnum.EDR_RECONCILLATION, id }],
    }),
    getInteractions: builder.query({
      queryFn: (_, { getState }, ___, baseQuery) => {
        return baseQuery({
          url: `${process.env.REACT_APP_XCALLY}/api/voice/calls/reports?apikey=${process.env.REACT_APP_ICALLY_KEY}`,
        });
      },
      providesTags: () => [RtkqTagEnum.ICALLY_INTERACTION],
    }),
  }),
});

export const nimbleX360MambuApi = createApi({
  reducerPath: "nimblex360Mambu",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_NX360_MAMBU_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set("XApiKey", process.env.REACT_APP_NX360_MAMBU_API_KEY);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMambuCustomerDetails: builder.query({
      query: (id) => ({ url: `/Mambu/get_customer_details_by_id/${id}` }),
    }),
    getMambuLoans: builder.query({
      query: (id) => ({ url: `/Mambu/get_loan_account_details/${id}` }),
    }),
    getMambuLoanTransactions: builder.query({
      query: (id) => ({ url: `/Mambu/get_loan_transaction_details/${id}` }),
    }),
    getMambuLoanComments: builder.query({
      query: (id) => ({ url: `/Mambu/get_loan_collection_comments/${id}` }),
    }),
    getMambuLoanActivities: builder.query({
      query: (id) => ({ url: `/Mambu/get_loan_collection_activity/${id}` }),
    }),

    getMosulendCustomerDetails: builder.query({
      query: (id) => ({
        url: `/Mosulend/get_customer_basic_details_by_customer_id/${id}`,
      }),
    }),
    getMosulendLoan: builder.query({
      query: (id) => ({
        url: `/Mosulend/get_customer_loan_details_by_customer_id/${id}`,
      }),
    }),
    getMosulendLoanProcess: builder.query({
      query: (id) => ({
        url: `/Mosulend/get_customer_loan_process_by_loan_id/${id}`,
      }),
    }),
    getMosulendLoanSettlement: builder.query({
      query: (id) => ({
        url: `/Mosulend/get_customer_loan_settlement_by_loan_id/${id}`,
      }),
    }),
    getUnsettledPendingLoans: builder.query({
      query: (id) => ({
        url: `/NX/get_customer_loan_details_by_loan_id/${id}`,
      }),
    }),
    getLoans: builder.query({
      query: (id) => ({
        url: `/NX/get_customer_loan_by_customer_id/${id}`,
      }),
    }),
  }),
});

export const nimbleX360Api = createApi({
  reducerPath: "nimbleX360Api",
  baseQuery: axiosBaseQuery(
    { url: `${process.env.REACT_APP_API_URL_BASE_PATH}/api/v1` },
    FineractHttp
  ),
  endpoints: (builder) => ({
    getCodeValues: builder.query({
      query: (code) => ({ url: `/codes/${code}/codevalues` }),
    }),
    getAgentGradeLevel: builder.query({
      query: (code) => ({ url: `/codes/${code}/codevalues` }),
    }),
    getStateLGA: builder.query({
      query: (stateId) => ({
        url: `/codes/27/codevalues/child/${stateId}`,
      }),
    }),
    resolveBVNDetails: builder.query({
      query: (bvn) => ({ url: `/fcmb/GetBvnDetails/${bvn}` }),
    }),
    getEmployers: builder.query({
      query: (params) => ({ url: `/employers`, params }),
    }),
    getBanks: builder.query({
      query: () => ({ url: `/banks` }),
    }),
    getValidateFCMBBank: builder.query({
      query: ({ path }) => ({
        url: `/fcmb/LocalNameEnquiry/${path.AccountNumber}`,
      }),
    }),
    getValidateOtherBank: builder.query({
      query: ({ path }) => ({
        url: `/Validation/ValidateAccountNumber/${path.AccountNumber}/${path.BankCode}`,
      }),
    }),
    getAuthUserProfile: builder.query({
      queryFn: (_, { getState }, ___, baseQuery) => {
        const { userId } = getState().global.authUser;
        return baseQuery({ url: `/users/${userId}` });
      },
    }),
    logout: builder.mutation({
      queryFn: (_, { getState }, ___, baseQuery) => {
        const { tfaToken } = getState().global.authUser || {};
        if (tfaToken) {
          return baseQuery({
            url: "/twofactor/invalidate",
            data: { token: tfaToken.token },
            method: "post",
          });
        }
        return { data: {} };
      },
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(logoutAction());
        } catch (error) {}
      },
    }),
    getWorkEmailOTP: builder.query({
      query: ({ clientId, workmail }) => ({
        url: `/clients/${clientId}/employers/otp/${workmail}`,
      }),
    }),
    validateWorkEmailOTP: builder.mutation({
      query: ({ clientId, ...body }) => ({
        url: `/clients/${clientId}/employers/otp/validate`,
        method: "POST",
        params: body,
      }),
    }),
  }),
});

export const documentWrapperApi = createApi({
  reducerPath: "documentWrapperApi",
  baseQuery: fetchBaseQuery({
    baseUrl: EnvKeys.REACT_APP_CBA,
  }),
  endpoints: (builder) => ({
    authenticate: builder.mutation({
      query: () => ({
        url: "/authenticate",
        method: "POST",
        body: {
          username: "nx-mobile",
          password: "nxMoBileP@55W0rd",
        },
      }),
    }),
    downloadCRMClientInvestmentCertificate: builder.query({
      queryFn: async ({ savingsId }, { dispatch }) => {
        try {
          const authResult = await dispatch(
            documentWrapperApi.endpoints.authenticate.initiate()
          ).unwrap();

          if (authResult.status === 200 && authResult.data?.accessToken) {
            const response = await fetch(
              `${EnvKeys.REACT_APP_CBA}/document-wrapper/api/v1/document/investmentletter/${savingsId}/download?documentSubTypeId=200&isUpgrade=false`,
              {
                headers: {
                  Authorization: `Bearer ${authResult.data.accessToken}`,
                },
              }
            );

            if (response.ok) {
              const blob = await response.blob();
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `investment-certificate-${savingsId}.pdf`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              return { data: { success: true } };
            } else {
              throw new Error(`Download failed: ${response.statusText}`);
            }
          } else {
            throw new Error("Authentication failed");
          }
        } catch (error) {
          return { error: { status: "FETCH_ERROR", error: error.message } };
        }
      },
    }),
  }),
});

export const neduWrapperX360Api = createApi({
  reducerPath: "neduWrapperX360Api",
  baseQuery: axiosBaseQuery({ url: `/api/v1` }, NeduWrapperHttp),
  endpoints: (builder) => ({}),
});

export const nimbleX360EDRApi = createApi({
  reducerPath: "nimbleX360EDRApi",
  baseQuery: axiosBaseQuery(
    { url: `${process.env.REACT_APP_API_URL_BASE_PATH}/api/v1` },
    FineractEDRHttp
  ),
  endpoints: (builder) => ({
    getCodeValues: builder.query({
      query: (code) => ({ url: `/codes/${code}/codevalues` }),
    }),
    getAgentGradeLevel: builder.query({
      query: (code) => ({ url: `/codes/${code}/codevalues` }),
    }),
    getStateLGA: builder.query({
      query: (stateId) => ({
        url: `/codes/27/codevalues/child/${stateId}`,
      }),
    }),
    resolveBVNDetails: builder.query({
      query: (bvn) => ({ url: `/fcmb/GetBvnDetails/${bvn}` }),
    }),
    getEmployers: builder.query({
      query: (params) => ({ url: `/employers`, params }),
    }),
    getBanks: builder.query({
      query: () => ({ url: `/banks` }),
    }),
    getValidateFCMBBank: builder.query({
      query: ({ path }) => ({
        url: `/fcmb/LocalNameEnquiry/${path.AccountNumber}`,
      }),
    }),
    getValidateOtherBank: builder.query({
      query: ({ path }) => ({
        url: `/Validation/ValidateAccountNumber/${path.AccountNumber}/${path.BankCode}`,
      }),
    }),
    getAuthUserProfile: builder.query({
      queryFn: (_, { getState }, ___, baseQuery) => {
        const { userId } = getState().global.authUser;
        return baseQuery({ url: `/users/${userId}` });
      },
    }),
    logout: builder.mutation({
      queryFn: (_, { getState }, ___, baseQuery) => {
        const { tfaToken } = getState().global.authUser || {};
        if (tfaToken) {
          return baseQuery({
            url: "/twofactor/invalidate",
            data: { token: tfaToken.token },
            method: "post",
          });
        }
        return { data: {} };
      },
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(logoutAction());
        } catch (error) {}
      },
    }),
    getWorkEmailOTP: builder.query({
      query: ({ clientId, workmail }) => ({
        url: `/clients/${clientId}/employers/otp/${workmail}`,
      }),
    }),
    validateWorkEmailOTP: builder.mutation({
      query: ({ clientId, ...body }) => ({
        url: `/clients/${clientId}/employers/otp/validate`,
        method: "POST",
        params: body,
      }),
    }),
  }),
});

export const nimbleX360WrapperApi = createApi({
  reducerPath: "nimbleX360WrapperApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_NX360_WRAPPER_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set(
        "Authorization",
        `Bearer ${process.env.REACT_APP_NX360_WRAPPER_API_KEY}`
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getresolveBVNDetails: builder.query({
      query: (bvn) => ({ url: `/Verification/ValidateBvn/${bvn}` }),
    }),
    getBanksDocument: builder.query({
      query: ({ accountNumber, mbsBankId, phoneNumber }) => ({
        url: `/channels/BankStatement/${accountNumber}/${mbsBankId}/${phoneNumber}/download`,
        responseHandler: async (response) => {
          console.log(`Response from download ===>`, response);

          const jsonResponse = await response.json(); // Parse the response as JSON
          if (jsonResponse.status && jsonResponse.data) {
            // Decode the Base64 string
            const binaryString = atob(jsonResponse.data);
            const binaryData = new Uint8Array(binaryString.length);

            for (let i = 0; i < binaryString.length; i++) {
              binaryData[i] = binaryString.charCodeAt(i);
            }

            // Create a Blob from the binary data
            const blob = new Blob([binaryData], { type: "application/pdf" });

            // Download the file
            downloadFile(blob, `BankStatement_${phoneNumber}.pdf`);
          } else {
            console.error("Failed to download the file:", jsonResponse.message);
          }
        },
        providesTags: (data) =>
          providesTags(data?.data, RtkqTagEnum.BANK_STATEMENTS),
      }),
    }),

    getMBSBanks: builder.query({
      query: () => ({
        url: `/channels/MbsBanks`,
      }),
    }),

    getAutoRepaymentCollection: builder.query({
      query: ({ loanId, ...params }) => ({
        url: `/Transaction/Paystack/GetSliderTransactions/${loanId}`,
        params,
      }),
    }),
    getCollectionInstructions: builder.query({
      query: ({ ...params }) => ({
        url: `/CollectionInstruction/GetCollectionInstructions`,
        params,
      }),
      providesTags: () => [{ type: RtkqTagEnum.RECOVERY_PAYMENT_INSTRUCTIONS }],
    }),
    getTokenizationTypes: builder.query({
      query: () => ({
        url: `/CollectionInstruction/GetTokenizationTypes`,
      }),
      providesTags: () => [{ type: RtkqTagEnum.RECOVERY_PAYMENT_INSTRUCTIONS }],
    }),
    getCreditCheckDocument: builder.query({
      query: (bvn) => ({ url: `/channels/CreditCheck/${bvn}/download` }),
    }),
    resolveBVNDetails: builder.mutation({
      query: ({ ...body }) => ({
        url: `/Verification/Kyc`,
        method: "POST",
        body: body,
      }),
    }),
    nameEnquiry: builder.mutation({
      query: ({ ...body }) => ({
        url: `/Verification/NameEnquiry`,
        method: "POST",
        body: body,
      }),
    }),
    addCreditReport: builder.query({
      query: ({ loanId, bvn }) => ({
        url: `/Channels/LoanAttachment/${loanId}/creditcheck/${bvn}`,
      }),
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          console.log("LoanAttachment...");
          dispatch(
            nimbleX360Api.util.invalidateTags([
              { type: RtkqTagEnum.CRM_LOAN_DOCUMENT },
            ])
          );
          dispatch(
            nimbleX360Api.util.invalidateTags([
              { type: RtkqTagEnum.CRM_DOCUMENT },
            ])
          );
        } catch {}
      },
    }),

    notification: builder.mutation({
      query: ({ ...body }) => ({
        url: `/Channels/Notification/OneSignal`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const nimbleX360WrapperBulkWriteOffApi = createApi({
  reducerPath: "nimbleX360WrapperBulkWriteOffApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_NX360_WRAPPER_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set(
        "Authorization",
        `Bearer ${process.env.REACT_APP_NX360_WRAPPER_BULK_WRITE_OFF_API_KEY}`
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({}),
});

export const sequestApi = createApi({
  reducerPath: "sequest",
  baseQuery: axiosBaseQuery({}, SequestHttp),
  endpoints: (builder) => ({}),
});

export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: axiosBaseQuery(
    { url: `${process.env.REACT_APP_API_URL_BASE_PATH}/api/v1` },
    PublicHttp
  ),
  endpoints: (builder) => ({}),
});

export const fineractExternalApi = createApi({
  reducerPath: "fineractExternalApi",
  baseQuery: axiosBaseQuery({ url: "/api/v1" }, FineractExternalHttp),
  endpoints: (builder) => ({
    uploadBulkReversal: builder.mutation({
      query: (config) => ({
        url: `/Nx360ReversalBulkService/upload`,
        method: "post",
        ...config,
        data: objectToFormData(config.data),
      }),
      // invalidatesTags: (_, error) =>
      //   invalidatesTags(RtkqTagEnum.RECONCILIATION_DISBURSEMENT),
    }),
  }),
});

export const cdlLeadsGenerationApi = createApi({
  reducerPath: "cdlLeadsGenerationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_LEADS_GENERATION_API,
    prepareHeaders: (headers, { getState }) => {
      const { sequest } = getState().global.authUser || {};
      if (sequest?.token) {
        headers.set("Authorization", `Bearer ${sequest?.token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getHealth: builder.query({
      query: (params) => ({
        url: `/health`,
        params,
      }),
      providesTags: () => [{ type: RtkqTagEnum.CRM_LEAD_GENERATION }],
    }),
    getProcessingStatusForLead: builder.query({
      query: (params) => ({
        url: `/file/progress-all`,
        params,
      }),
      providesTags: () => [{ type: RtkqTagEnum.CRM_LEAD_GENERATION }],
    }),
    getProcessingStatus: builder.query({
      query: (id, params) => ({
        url: `/file/progress/${id}`,
        params,
      }),
      providesTags: () => [{ type: RtkqTagEnum.CRM_LEAD_GENERATION }],
    }),
    getProcessingStatusDetail: builder.query({
      query: ({ id, batchId, ...params }) => ({
        url: `/file/export/${id}/${batchId}`,
        params,
      }),
      providesTags: () => [{ type: RtkqTagEnum.CRM_LEAD_GENERATION }],
    }),
    uploadLeadGenerationFile: builder.mutation({
      query: (config) => ({
        url: `/file`,
        method: "POST",
        ...config,
        body: objectToFormData(config?.body),
      }),
      invalidatesTags: () => [{ type: RtkqTagEnum.CRM_LEAD_GENERATION }],
    }),
  }),
});

export const cdlEDRReconciliationApi = createApi({
  reducerPath: "cdlEDRReconciliationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_NX360_EDR_WRAPPER_API,
    prepareHeaders: (headers, { getState }) => {
      const { authUser } = getState().global;
      const { base64EncodedAuthenticationKey, tfaToken } = authUser || {};

      headers.set(
        "Authorization",
        `Bearer ${process.env.REACT_APP_NX360_EDR_WRAPPER_API_KEY}`
      );

      headers.set("auth", `Basic ${base64EncodedAuthenticationKey}`);
      headers.set("Fineract-Platform-Tfa-Token", `${tfaToken.token}`);
      headers.set("Fineract-Platform-TenantId", "default");
      headers.set("Channel", "0");

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getEDRPaypointView: builder.query({
      query: ({ ...params }) => ({
        url: `/v1/edr/paypoint/view`,
        params,
      }),
      providesTags: () => [RtkqTagEnum.EDR_RECONCILLATION],
    }),

    getCRMPaypointEDRUploadedReport: builder.query({
      query: (params) => ({ url: "/v1/uploads", params }),
      providesTags: (data) =>
        providesTags(data?.pageItems, RtkqTagEnum.CRM_EMPLOYER),
    }),

    getLoanProductGroups: builder.query({
      query: (params) => ({ url: "/v1/uploads/product-groups", params }),
      providesTags: (data) =>
        providesTags(data?.pageItems, RtkqTagEnum.LOAN_PRODUCT_GROUPS),
    }),

    getCRMPaypointRetrieveSettlementSummary: builder.query({
      query: (id) => ({ url: `/v1/uploads/summary/${id}` }),
      providesTags: (data) =>
        providesTags(
          data?.content,
          RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS
        ),
    }),

    getCRMPaypointSettlementList: builder.query({
      query: ({ id, ...params }) => ({
        url: `/v1/edr-settlements/${id}`,
        params,
      }),
      providesTags: (data) =>
        providesTags(
          data?.content,
          RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS
        ),
    }),

    downloadEDRSettlementReport: builder.query({
      query: ({ id, ...params }) => ({
        url: `/v1/edr-settlements/downloadReport/${id}`,
        params,
        responseHandler: async (response) => {
          downloadFile(
            await response.blob(),
            `EDR_REPAYMENT_REPORT_${id}.xlsx`
          );
        },
        providesTags: (data) =>
          providesTags(
            data?.content,
            RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS
          ),
      }),
    }),
    downloadEDRDisbursementTemplate: builder.query({
      query: () => ({
        url: `/v1/disburse/template/`,
        responseHandler: async (response) => {
          downloadFile(await response.blob(), `EDR_DISBURSEMENT_TEMPLATE.csv`);
        },
      }),
    }),
    processEDRSettlement: builder.mutation({
      query: (config) => ({
        url: `/v1/edr-settlements/${config?.id}/process`,
        ...config,
        method: "POST",
      }),
      invalidatesTags: () => [
        { type: RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS },
      ],
    }),

    retryProcessEDRSettlement: builder.mutation({
      query: ({ id, ...config }) => ({
        url: `/v1/uploads/${id}/retry`,
        body: config,
        method: "POST",
      }),
      invalidatesTags: () => [
        { type: RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS },
      ],
    }),

    undoProcessEDRSettlement: builder.mutation({
      query: ({ id, ...config }) => ({
        url: `/v1/uploads/${id}/undo`,
        body: config,
        method: "POST",
      }),
      invalidatesTags: () => [
        { type: RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS },
      ],
    }),

    uploadEDRReconciliationFile: builder.mutation({
      query: (config) => ({
        url: `/v1/edr/upload/${config?.body?.id}`,
        ...config,
        method: "POST",
        body: objectToFormData(config?.body),
      }),
      invalidatesTags: (_, error) =>
        invalidatesTags(RtkqTagEnum.EDR_RECONCILLATION),
    }),

    edrVersionLock: builder.mutation({
      query: (config) => ({
        url: `/v1/edr/lock/${config?.payPointId}/${config?.uploadId}`,
        ...config,
        method: "POST",
      }),
      invalidatesTags: () => [{ type: RtkqTagEnum.EDR_RECONCILLATION_DETAILS }],
    }),

    getEDRPaypointVersions: builder.query({
      query: ({ id, ...params }) => ({
        url: `/v1/edr/versions/${id}`,
        params,
      }),
      providesTags: () => [{ type: RtkqTagEnum.EDR_RECONCILLATION_DETAILS }],
    }),

    getEDRDashboard: builder.query({
      query: ({ ...params }) => ({
        url: `/v1/edr/${params?.payPointId}/${params?.uploadId}`,
        params,
      }),
      providesTags: (id) => [RtkqTagEnum.EDR_RECONCILLATION_DASHBOARD],
    }),

    getEDRDashboardReconciliationList: builder.query({
      query: ({ uploadId, ...params }) => ({
        url: `/v1/edr-recon/${uploadId}`,
        params,
      }),
      providesTags: (id) => [RtkqTagEnum.EDR_RECONCILLATION_DASHBOARD],
    }),

    downloadEDRRecords: builder.query({
      query: (id) => ({
        url: `/v1/edr-recon/downloadReport/${id}`,
        responseHandler: async (response) => {
          downloadFile(await response.blob(), `EDR_RECONCILLATION_${id}.xlsx`);
        },
      }),
    }),

    downloadEDRSettlementTemplate: builder.query({
      query: () => ({
        url: `/v1/edr-settlements/template/`,
        responseHandler: async (response) => {
          downloadFile(await response.blob(), `EDR_REPAYMENT_TEMPLATE.csv`);
        },
      }),
    }),

    getClientNotes: builder.query({
      query: ({ clientId, ...params }) => ({
        url: `/v1/notes/${clientId}`,
        method: "GET",
        params,
      }),
    }),

    downloadEDRBulkNoteUploadTemplate: builder.query({
      query: () => ({
        url: `/v1/notes/template/`,
        responseHandler: async (response) => {
          downloadFile(
            await response.blob(),
            `EDR_BULK_NOTE_UPLOAD_TEMPLATE.csv`
          );
        },
      }),
    }),
    // getClientEDRInflow: builder.query({
    //   query: (loanId) => ({
    //     url: `/v1/edr-settlements/${loanId}/edr-loan-inflow`,
    //   }),
    // }),

    getClientEDRInflow: builder.query({
      query: ({ loanId, ...params }) => ({
        url: `/v1/edr-settlements/${loanId}/edr-loan-inflow`,
        method: "GET",
        params,
      }),
    }),

    getClientEDRInflowNew: builder.query({
      query: ({ clientId, ...params }) => ({
        url: `/v1/edr-settlements/${clientId}/edr-inflow`,
        method: "GET",
        params,
      }),
    }),

    uploadEDRSettlementTemplateFile: builder.mutation({
      query: (config) => ({
        url: `/v1/edr-settlements/${config?.data?.paypointId}`,
        ...config?.data,
        method: "POST",
        body: objectToFormData(config?.data),
      }),
      invalidatesTags: (_, error) =>
        invalidatesTags(RtkqTagEnum.EDR_RECONCILLATION),
    }),

    uploadEDRBulkNoteUploadTemplateFile: builder.mutation({
      query: (config) => ({
        url: `/v1/notes`,
        ...config?.data,
        method: "POST",
        body: objectToFormData(config?.data),
      }),
      invalidatesTags: (_, error) => invalidatesTags(RtkqTagEnum.CRM_CLIENT),
    }),

    uploadBulkLoanForActivationFile: builder.mutation({
      queryFn(config, api, extraOptions, baseQuery) {
        // const { authUser } = api.getState().global;
        return baseQuery({
          url: `v1/disburse/bulk_loans`,
          ...config,
          method: "POST",
          body: objectToFormData(config?.body),
        });
      },
      invalidatesTags: (_, error) =>
        invalidatesTags(RtkqTagEnum.LOAN_DISBURSAL_EXCEPTION),
    }),

    uploadEDRSettlementRefundTemplateFile: builder.mutation({
      query: (config) => ({
        url: `/v1/refundTransactions`,
        ...config?.data,
        method: "POST",
        body: objectToFormData(config?.data),
      }),
      invalidatesTags: (_, error) =>
        invalidatesTags(RtkqTagEnum.EDR_RECONCILLATION),
    }),
    downloadEDRSettlementRefundTemplate: builder.query({
      query: () => ({
        url: `/v1/refundTransactions/template`,
        responseHandler: async (response) => {
          downloadFile(await response.blob(), `EDR_REFUND_TEMPLATE.csv`);
        },
      }),
    }),
    processEDRSettlementRefund: builder.mutation({
      query: (config) => ({
        url: `/v1/refundBatch/${config?.path?.id}`,
        body: config?.body,
        method: "POST",
      }),
      invalidatesTags: () => [
        { type: RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS },
      ],
    }),
    getSettlementRefundSummary: builder.query({
      query: (id) => ({ url: `/v1/refundBatch/summary/${id}` }),
      providesTags: (data) =>
        providesTags(
          data?.content,
          RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS
        ),
    }),
    getSettlementRefundList: builder.query({
      query: ({ id, ...params }) => ({
        url: `/v1/refundTransactions/summary/${id}`,
        params,
      }),
      providesTags: (data) =>
        providesTags(
          data?.content,
          RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS
        ),
    }),
    downloadEDRSettlementRefundReport: builder.query({
      query: ({ id, ...params }) => ({
        url: `/v1/refundBatch/downloadReport/${id}`,
        params,
        responseHandler: async (response) => {
          downloadFile(await response.blob(), `EDR_REFUND_REPORT_${id}.xlsx`);
        },
        providesTags: (data) =>
          providesTags(
            data?.content,
            RtkqTagEnum.EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS
          ),
      }),
    }),
  }),
});

export const cdlEDRInflowApi = createApi({
  reducerPath: "cdlEDRInflowApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_FINERACT_EXTERNAL_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const { authUser } = getState().global;
      const { base64EncodedAuthenticationKey, tfaToken } = authUser || {};

      headers.set(
        "Authorization",
        `Bearer ${process.env.REACT_APP_FINERACT_EXTERNAL_API_KEY}`
      );

      headers.set("auth", `Basic ${base64EncodedAuthenticationKey}`);

      headers.set("Fineract-Platform-Tfa-Token", `${tfaToken.token}`);
      headers.set("Fineract-Platform-TenantId", "default");
      headers.set("Channel", "0");

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getClientEDRInflow: builder.query({
      query: (loanId) => ({
        url: `/edr-settlements/${loanId}/edr-loan-inflow`,
      }),
    }),
  }),
});

export const zeusApi = createApi({
  reducerPath: "zeusApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_ZEUS_BASE_URI_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set(
        "Authorization",
        `Bearer ${process.env.REACT_APP_ZEUS_BASE_URI_API_KEY}`
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    resetUserPin: builder.mutation({
      query: (body) => ({
        url: "/user/reset_pin",
        method: "POST",
        body,
      }),
    }),
    getSavingsInvestmentLetter: builder.query({
      query: ({
        savingsId,
        clientId,
        email,
        name,
        firstname,
        send,
        savingsType,
        format,
      }) => ({
        url: `/savings/investment_letter`,
        params: {
          savingsId,
          clientId,
          email,
          name,
          firstname,
          send,
          savingsType,
          format,
        },
      }),
    }),
  }),
});

export const { useResetUserPinMutation } = zeusApi;

export const nx360HookApi = createApi({
  reducerPath: "nx360HookApi",
  baseQuery: axiosBaseQuery(
    { url: `${process.env.REACT_APP_NX360_HOOK_API_URL}/api` },
    HookHttp
  ),
  endpoints: (builder) => ({
    generateTransactionReference: builder.mutation({
      query: (config) => ({
        url: `/Transaction/reference/generate`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});

export const nipSupportApi = createApi({
  reducerPath: "nipSupportApi",
  baseQuery: axiosBaseQuery(
    { url: `${process.env.REACT_APP_NIP_SUPPORT_API_URL}` },
    nipSupportHttp
  ),
  endpoints: (builder) => ({}),
});

export const outwardTransactionsApi = createApi({
  reducerPath: "outwardTransactionsApi",
  baseQuery: axiosBaseQuery(
    { baseURL: `${EnvKeys.REACT_APP_OUTWARD_TRANSACTION_API_URL}/v1/api/` }, //process.env.REACT_APP_OUTWARD_TRANSACTION_API_URL
    outwardTransactionHttp
  ),
  endpoints: (builder) => ({}),
});

export const impairmentApi = createApi({
  reducerPath: "impairmentApi",
  baseQuery: axiosBaseQuery(
    { url: `${process.env.REACT_APP_IMPAIRMENT_API}` },
    ImpairmentHttp
  ),
  endpoints: (builder) => ({}),
});

export const businessBankingApi = createApi({
  reducerPath: "businessBankingApi",
  baseQuery: customFetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BUSINESS_BANKING_API_BASE_URL}/v1/api`,
    prepareHeaders(headers, { getState }) {
      headers = new Headers(headers);

      const { authUser } = (getState() as any)?.global ?? {};

      const token = authUser?.base64EncodedAuthenticationKey;
      const tfaToken = authUser?.tfaToken?.token;
      const user = {
        id: authUser?.id ?? "",
        email: authUser?.email || "",
        phone: "",
        name: authUser?.fullname || "",
      };

      if (token) {
        headers.set("auth", `Basic ${token}`);
        headers.set("tenantid", "default");
        headers.set("token", tfaToken);
        headers.set("user", JSON.stringify(user || {}));
      }

      headers.set("ngrok-skip-browser-warning", "true");

      return headers;
    },
    fetchFn: async (...arg) => {
      const response = await fetch(...arg);

      // if (response.status == 401) {
      //   store.dispatch(logout());
      //   window.location.reload();
      // }

      return response;
    },
  }),
  endpoints: (builder) => ({
    getManualVerification: builder.query({
      query: ({ status }) => ({
        url: `/nx360/manual-verification`,
        params: { status },
      }),
    }),
    getManualVerificationDetailsById: builder.query({
      query: ({ id }) => ({
        url: `/nx360/manual-verification/${id}`,
      }),
    }),
    patchManualVerificationById: builder.mutation({
      query: ({ id, action, ...body }) => ({
        url: `/nx360/manual-verification/${id}`,
        params: { action },
        method: "PATCH",
        ...body,
      }),
    }),
    getDocumentByKey: builder.mutation({
      query: (key) => ({
        url: `/nx360/document`,
        method: "GET",
        params: {
          key,
        },
      }),
    }),
    getBusinessByRcNumber: builder.mutation({
      query: (rcNumber) => ({
        url: `/nx360/business/rc-number/${rcNumber}`,
        method: "GET",
      }),
    }),
  }),
}).enhanceEndpoints({ addTagTypes: Object.values(BusinessBankingTags) });

export const paySyncApi = createApi({
  reducerPath: "paySyncApi",
  baseQuery: axiosBaseQuery({ url: `/api` }, paySyncHttp),
  endpoints: (builder) => ({}),
});

[
  nimbleX360Api,
  sequestApi,
  publicApi,
  nimbleX360MambuApi,
  creditDirectApi,
  nimbleX360WrapperApi,
  fineractExternalApi,
  cdlLeadsGenerationApi,
  cdlEDRReconciliationApi,
  cdlEDRInflowApi,
  nx360HookApi,
  nipSupportApi,
  impairmentApi,
  paySyncApi,
  zeusApi,
  outwardTransactionsApi,
  businessBankingApi,
].forEach((api) => {
  api.enhanceEndpoints({ addTagTypes: Object.values(RtkqTagEnum) });
});

/**
 *
 * @param {import("axios").AxiosRequestConfig} baseConfig
 */
export function axiosBaseQuery(baseConfig = {}, http = axios) {
  return request;

  /**
   *
   * @param {import("axios").AxiosRequestConfig} config
   */
  async function request({
    // public: _public,
    concatBaseConfigUrl = true,
    ...config
  } = {}) {
    const url = config.url
      ? (concatBaseConfigUrl ? baseConfig.url || "" : "") + config.url
      : baseConfig.url;

    try {
      const response = await http.request({ ...baseConfig, ...config, url });

      return {
        ...response,
        data: response.data,
        message: response.data?.message || null,
        status: response.status || 200,
        meta: { request: response.request, response },
      };
    } catch (error) {
      // console.log("axiosBaseQuery-Error", error);
      return {
        error: error.response
          ? {
              defaultUserMessage:
                error.response.data?.errors?.[0]?.defaultUserMessage ||
                "Something went wrong",
              status: error.response.status,
              data: error.response.data,
            }
          : {
              defaultUserMessage: "Something went wrong",
              data: { defaultUserMessage: "Something went wrong" },
            },
      };
    }
  }
}

export function providesTags(resultsWithIds, tagType, options = {}) {
  const { selectId = ({ id }) => id } = options;
  const listTag = { type: tagType, id: "LIST" };
  const result = resultsWithIds
    ? [
        listTag,
        ...resultsWithIds.map((result) => ({
          type: tagType,
          id: selectId(result || {}) || "ITEM",
        })),
      ]
    : [listTag];

  return result;
}

export function invalidatesTags(tagType, options = {}) {
  const { ids = [] } = options;
  const result = [
    { type: tagType, id: "LIST" },
    ...ids.map((id) => ({ type: tagType, id })),
  ];

  return result;
}

function customFetchBaseQuery({
  prepareArgs = (args) => args,
  ...baseArg
}: CustomFetchBaseQueryOptions) {
  const fetchQuery = fetchBaseQuery(baseArg);

  return (async (args, api, extraOptions) => {
    const newArgs = await prepareArgs(
      ((args) => {
        return {
          ...args,
          headers: args.headers ?? new Headers(baseArg?.headers),
        };
      })(typeof args == "string" ? { url: args } : args),
      api,
      extraOptions
    );
    return await fetchQuery(newArgs, api, extraOptions);
  }) as typeof fetchQuery;
}

type CustomFetchBaseQueryOptions = {
  prepareArgs?: (
    args: FetchArgs,
    api: BaseQueryApi,
    extraOptions: any
  ) => MaybePromise<FetchArgs>;
} & Parameters<typeof fetchBaseQuery>[0];

type MaybePromise<T> = T | PromiseLike<T>;
